import React from "react";
import { DRAPERY_SEWING_MODEL_IDS } from "./draperyConstants";

export const faNumberFormatter = new Intl.NumberFormat("fa-IR");

export const formatFaNumber = (value) => faNumberFormatter.format(value);

export const lookupFa = (map, value) => map[value] || value;

export const faOrEn = (pageLanguage, map, value) =>
  pageLanguage === "fa" ? lookupFa(map, value) : value;

export const isDraperySewingModel = (sewingModelId) =>
  sewingModelId === DRAPERY_SEWING_MODEL_IDS[0] || sewingModelId === DRAPERY_SEWING_MODEL_IDS[1];

export const formatMotorChannels = (channels, pageLanguage) =>
  pageLanguage === "fa"
    ? channels.join(",").replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    : channels.join(",");

export const normalizeOutsideMountSubType = (isWalled, installationLocation) => {
  if (installationLocation && installationLocation !== "undefined") {
    return installationLocation;
  }
  if (isWalled === true || isWalled === "true") return "Wall";
  if (isWalled === false || isWalled === "false") return "Ceiling";
  return isWalled || null;
};

export const formatCombinedOutsideMountLabel = (subType, pageLanguage, t) => {
  if (!subType) return null;
  if (pageLanguage === "fa") {
    return subType === "Wall"
      ? t("TO DETERMINE OUTSIDE MOUNT_WALL")
      : t("TO DETERMINE OUTSIDE MOUNT CEILING");
  }
  return `Outside / ${t(subType)} Mount`;
};

export function FabricsSectionTitle({ title }) {
  return (
    <div style={{ marginTop: "0.5rem" }}>
      <hr />
      <h1 className="cart_agree_item_fabrics_sorted_title" style={{ marginTop: "0.2rem" }}>
        {title}
      </h1>
    </div>
  );
}
